import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type Cohort } from './types';
import { useShouldShowEmbeddedConfluence } from './hooks/useShouldShowEmbeddedConfluence';
import { fireExposure } from './utils';

type Props = {
	isConfluenceActivationCompleteForPreselectedTemplate: boolean;
};

export const SelectedTemplatePreviewAA = ({
	isConfluenceActivationCompleteForPreselectedTemplate,
}: Props): JSX.Element | null => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useShouldShowEmbeddedConfluence({
		isConfluenceActivationCompleteForPreselectedTemplate,
		onShouldShowEmbeddedConfluence() {
			const cohort = FeatureGates.getExperimentValue<Cohort>(
				'project-pages-embedded-confluence-aa',
				'cohort',
				'not-enrolled',
			);
			fireExposure({
				event: createAnalyticsEvent({
					type: 'sendTrackEvent',
					action: 'viewed',
				}),
				experimentType: 'aa',
				cohort,
			});
			return true;
		},
	});

	return null;
};
